import React, { Fragment } from "react";
import i18next from "i18next";
import { withTranslation, Trans } from "react-i18next";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import Checkbox from "@material-ui/core/Checkbox";
import FormGroup from "@material-ui/core/FormGroup";
import Input from "@material-ui/core/Input";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import FormLabel from "@material-ui/core/FormLabel";
import Select from "@material-ui/core/Select";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import classnames from "classnames";
import Services from "../../api/api";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { setLangID } from "../../redux/actions/appActions";
import DependentQuestionnaire from "./DependentQuestionnaire";
import CheckboxQues from "./checkbox";
import RadioElements from "./radioElements";

const useStyles = (theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    width: "-webkit-fill-available",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
    backgroundColor: "rgba(0, 0, 0, .02)",
  },
});

let dependantquestionArr = [];

class Questionnaire extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      questionlist: [],
      dependantquestionlist: [],
      dependantquestionArr: [],
      isLoading: false,
      showSlider: true,
      temp: false,
      animCssClasses: "animate__animated animate__zoomIn animate__faster",
    };
    this.handleChangeCheckbox = this.handleChangeCheckbox.bind(this)
    this.handleChangeRadio = this.handleChangeRadio.bind(this)
  }

  componentDidMount() { }

  static getDerivedStateFromProps(nextProps) {
    return {
      animCssClasses: nextProps.animCssClasses,
      showSlider: nextProps.showSlider,
    };
  }

  renderQuestion() {
    const { classes } = this.props;
    var element = this.props.question;
    const { templateID } = this.props;
    let bgStyles = templateID == 2 ? { background: this.props.componentbgcolor } : {};
    let colorStyles = templateID == 2 ? { color: this.props.componentbgcolor } : {};
    var quslist = [];
    return (
      <>
        <Grid
          key={element.id}
          container
          spacing={0}
          className="gridcontainer chatuserlistdiv"
        >
          <Grid item xs={2} className="zero">
            <p className="zero  text-center forumicon">
              <LockOpenIcon style={bgStyles}/>
            </p>
          </Grid>
          <Grid item xs={10} className="zero">
            <p className="zero chatusername"  style={colorStyles}>{element.question}</p>
          </Grid>
        </Grid>
        <div className={classes.root}>
          <div className="optionset">
            <FormControl component="fieldset" className={classes.formControl}>
              <FormGroup>{this.getQuestionType(element)}</FormGroup>
            </FormControl>
            {
                this.state.dependantquestionlist.length > 0 ?
                  (
                    this.state.dependantquestionlist.map((Obj) => {
                      return <DependentQuestionnaire parentId={element.id} question={Obj} />;
                    })
                  )
                  : ''
              }
          </div>
        </div>
      </>
    );
  }

  getQuestionType(element) {
    var type  = element.type ? element.type.toLowerCase() : ''
    switch (type) {
      case "text":
        return this.getTextType(element);
      case "date":
        return this.getDateType(element);
      case "radio":
        return this.getRadioType(element);
      case "checkbox":
        return this.getCheckboxType(element);
      case "number":
        return this.getNumberType(element);
    }
  }


  handleChangeCheckbox(event) {
    var values = parseInt(event.target.value)
    // if (event.target.checked) {
    //   dependantquestionArr.push(values)
    // } else {
    //   dependantquestionArr = dependantquestionArr.filter(c => c !== values)
    // }
    // if (this.props.question.dependentQuestionsList.length > 0) {
    //   var dependList = this.props.question.dependentQuestionsList.filter(o => dependantquestionArr.includes(o.selectedOption))
    //   this.setState({ dependantquestionlist: dependList })
    // }
  }


  handleChangeRadio(values) {
    var color = this.props.question.colorMap[values]
    this.props.onQuestionClick(color)
    // if (this.props.question.dependentQuestionsList && this.props.question.dependentQuestionsList.length > 0) {
    //     var dependList = this.props.question.dependentQuestionsList.filter(o =>  o.selectedOption == values)
    //     this.setState({dependantquestionlist: dependList})
    // }
  }

  getTextType(element) {
    return (
      <FormControlLabel
        className="getinvolvedtextboxholder"
        name={"text-" + element.id}
        control={
          <TextField name={'text-' + element.id} />
        }
      />
    );
  }

  getNumberType(element) {
    return (
      <FormControlLabel
        className="getinvolvedtextboxholder"
        name={"text-" + element.id}
        control={
          <TextField type="tel" inputProps={{
            pattern: "[0-9]*",
        }} name={'text-' + element.id} />
        }
      />
    );
  }

  getDateType(element) {
    return (
      <FormControlLabel
        className="getinvolvedtextboxholder"
        name={"text-" + element.id}
        control={
          <TextField type="date" name={'date-' + element.id} />
        }
      />
    );
  }

  getRadioType(element) {
    let values = element.response != undefined ? element["response"]["value"][0] : '';
    let name = "radio-" + element.id
    return <RadioElements type={'parent'}  values={values} name={name}  element={element} handleChangeRadio={this.handleChangeRadio} ></RadioElements>
  }

  getCheckboxType(element) {
    var checkbuttons = [];
    let keys = Object.keys(element.optionMap);
    keys.map((o, i) => {
      let checked = element.response && element.response.value.includes(o) ? true : false;
      checkbuttons.push(
        <CheckboxQues
          key={i}
          value={o}
          checkedFalg={checked}
          name={"check-" + element.id}
          label={element.optionMap[o]}
          element={element}
        >
        </CheckboxQues>
      );
    });
    return <FormGroup>{checkbuttons}</FormGroup>;
  }

  render() {
    const { classes } = this.props;
    const { t } = this.props;
    if (this.props.question) {
      return <>{this.renderQuestion()}</>;
    }
    return null;
  }
}



const mapStateToProps = (state) => {
  let { storeState } = state;
  return {
    templateID: JSON.parse(localStorage.getItem('templateID')) != null ? JSON.parse(localStorage.getItem('templateID')) : storeState.templateID,
    communityuid: storeState.communityId,
    langId: storeState.langId,
    componentbgcolor: storeState.componentbgcolor
  };
};

let newQuestionnaire = withStyles(useStyles)(withTranslation()(Questionnaire));
export default connect(mapStateToProps, {})(newQuestionnaire);